export const getButtonColumns = ({ buttonsCount, vertical }) => {
  if (vertical) return 12;
  return 12 / buttonsCount;
};

export default { getButtonColumns };
